import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Info, Sparkles } from "lucide-react";

export const AddResourceDialog = ({ open, onOpenChange, cfg, kk, form, setForm, onSave, saving, aiBrief, setAiBrief, onAiDraft, aiLoading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid={`${kk}-dialog`}>
      <DialogHeader><DialogTitle>{cfg.addLabel}</DialogTitle></DialogHeader>
      <div className="space-y-3">
        {cfg.aiDraft && (
          <div className="rounded-xl border border-purple-100 bg-purple-50/60 p-3">
            <Label className="flex items-center gap-1.5 text-xs font-semibold text-purple-700"><Sparkles className="h-3.5 w-3.5" /> Draft with AI</Label>
            <Textarea value={aiBrief} onChange={(e) => setAiBrief(e.target.value)} rows={2} data-testid="ai-draft-brief" className="mt-1 bg-white"
              placeholder="e.g. 5 day Bali honeymoon for a couple, mid-range, beaches + one island tour" />
            <button type="button" onClick={onAiDraft} disabled={aiLoading} data-testid="ai-draft-btn"
              className="mt-2 inline-flex items-center gap-2 rounded-full brand-gradient-bg px-4 py-2 text-xs font-semibold text-white disabled:opacity-50">
              <Sparkles className="h-3.5 w-3.5" /> {aiLoading ? "Drafting..." : "Generate draft"}
            </button>
            <p className="mt-1.5 text-[11px] text-purple-400">AI fills the title, destination & inclusions. It never invents prices — you set those.</p>
          </div>
        )}
        {cfg.fields.map((f) => (
          <div key={f.key}>
            <Label className="text-xs text-slate-500">{f.label}{f.required && " *"}</Label>
            {f.type === "textarea" ? (
              <Textarea value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={`field-${f.key}`} className="mt-1" />
            ) : f.type === "select" ? (
              <Select value={form[f.key] || ""} onValueChange={(v) => setForm({ ...form, [f.key]: v })}>
                <SelectTrigger className="mt-1" data-testid={`field-${f.key}`}><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent>{f.options.map((o) => <SelectItem key={o} value={o}>{o.replace(/_/g, " ")}</SelectItem>)}</SelectContent>
              </Select>
            ) : (
              <Input type={f.type === "number" ? "number" : f.type === "date" ? "date" : "text"}
                value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                placeholder={f.placeholder} data-testid={`field-${f.key}`} className="mt-1" />
            )}
          </div>
        ))}
        <div className="flex items-start gap-1.5 rounded-lg bg-blue-50 p-2.5 text-[11px] text-blue-600">
          <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" /> This record is saved to your private Suffle account. Suffle never fabricates data.
        </div>
      </div>
      <button onClick={onSave} disabled={saving} data-testid={`${kk}-save`}
        className="mt-2 w-full rounded-xl brand-gradient-bg py-2.5 font-semibold text-white disabled:opacity-50">
        {saving ? "Saving..." : "Save"}
      </button>
    </DialogContent>
  </Dialog>
);
